import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-redux-i18n';
import { Paginator } from 'front-onceforall-core';
import Action from './action';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export const ActiveRequestActionsView = props => {
  if (props.requests.length === 0 && !props.error) {
    return null;
  }
  const rows = props.requests.map(request => /*#__PURE__*/_jsx(Action, {
    history: props.history,
    request: request,
    organisations: props.organisations
  }, request.id));
  return /*#__PURE__*/_jsx("div", {
    className: "card col-12",
    children: props.error ? /*#__PURE__*/_jsx("span", {
      "data-id": "error-message",
      children: /*#__PURE__*/_jsx(Translate, {
        value: "error.generic"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [rows, /*#__PURE__*/_jsx(Paginator, {
        totalItems: props.requestsCount,
        pageSize: props.pageSize,
        currentPage: props.page,
        onChangePage: props.onPageChange
      })]
    })
  });
};
ActiveRequestActionsView.propTypes = {
  history: PropTypes.object.isRequired,
  organisations: PropTypes.array.isRequired,
  requests: PropTypes.array.isRequired,
  requestsCount: PropTypes.number.isRequired,
  page: PropTypes.number,
  pageSize: PropTypes.number,
  error: PropTypes.bool,
  onPageChange: PropTypes.func.isRequired
};
ActiveRequestActionsView.defaultProps = {
  page: 0,
  pageSize: 10,
  error: false
};
export default ActiveRequestActionsView;